import React, { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  makeStyles,
  useMediaQuery,
  CircularProgress,
} from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import { useQuery, useLazyQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";

import moment from "moment";
import Button from "../../components/Button";
import { Card, CardActions, CardContent } from "../../components/Card";
import { DateInput, Select, TextInput } from "../../components/Form";
import Table from "../../components/Table";
import { useAlert } from "../../components/Alert";
import LoadingModal from "../../components/LoadingModal";

const GET_PERSONALMESSAGES = gql`
  query personalMessages(
    $id: Int
    $type: PersonalMessageType
    $searchTerm: String
    $latest: Boolean
    $status: AssignmentStatus
    $pageSize: Int
    $page: Int
  ) {
    personalMessages(
      id: $id
      type: $type
      searchTerm: $searchTerm
      latest: $latest
      status: $status
      pageSize: $pageSize
      page: $page
    ) {
      count
      pageCount
      contents {
        id
        category {
          id
          name
          createdAt
          updatedAt
        }
        task
        response
        status
        statusUpdatedAt
        expectedFinishedAt
        shouldFinishAt
        finishedAt
        assignTo {
          id
          fullName
        }
        assignedBy {
          id
          fullName
        }
        updatedBy {
          id
          fullName
        }
        createdAt
        updatedAt
      }
    }
  }
`;
const GET_ASSIGNMENTCATEGORIES = gql`
  query assignmentCategories {
    assignmentCategories {
      id
      name
    }
  }
`;
const GET_USERS = gql`
  query users {
    users {
      contents {
        id
        fullName
      }
    }
  }
`;
const SAVE_ASSIGNMENT = gql`
  mutation saveAssignment($assignmentInput: AssignmentInput!) {
    saveAssignment(assignmentInput: $assignmentInput)
  }
`;
const DELETE_ASSIGNMENT = gql`
  mutation deleteAssignment($id: Int!) {
    deleteAssignment(id: $id)
  }
`;
const SAVE_ASSIGNMENTCATEGORY = gql`
  mutation saveAssignmentCategory($name: String!) {
    saveAssignmentCategory(name: $name)
  }
`;
const DELETE_ASSIGNMENTCATEGORY = gql`
  mutation deleteAssignmentCategory($id: Int!) {
    deleteAssignmentCategory(id: $id)
  }
`;
const UPDATE_ASSIGNMENTSTATUS = gql`
  mutation updateAssignmentStatus(
    $id: Int!
    $assignmentStatus: AssignmentStatus!
  ) {
    updateAssignmentStatus(id: $id, assignmentStatus: $assignmentStatus)
  }
`;
export default function AssignmentsTable() {
  const Alert = useAlert();
  const isPhone = useMediaQuery("(max-width:576px)");
  const [newData, setNewData] = useState({
    addOpen: false,
    replyOpen: false,
    editOpen: false,
    editCategoryOpen: false,
    searchTerm: "",
    statusArray: [
      { label: "待決策", value: "TO_BE_DECIDED" },
      { label: "未進行", value: "PENDING" },
      { label: "進行中", value: "IN_PROGRESS" },
    ],
    statusObject: {},
    data: {},
    page: 1,
    pageMax: null,
    pageSize: 10,
    pageArray: [],
  });
  const { data, refetch, loading } = useQuery(GET_PERSONALMESSAGES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      id: Number(localStorage.getItem("@fullhouseUserId")),
      type: "ASSIGNMENT",
      searchTerm: newData.searchTerm,
      latest: true,
      status: newData.statusObject.value,
      pageSize: 10,
      page: newData.page,
    },
    onError(error) {
      return Alert.notice(error.message.replace("GraphQL error: ", ""));
    },
  });
  const [deleteAssignment, { loading: deleteAssignmentLoading }] = useMutation(
    DELETE_ASSIGNMENT,
    {
      onCompleted({ deleteAssignment }) {
        if (deleteAssignment) {
          Alert.alert("", "刪除成功", [
            {
              text: "確定",
              onPress: () => {
                refetch();
              },
              type: "ok",
            },
          ]);
        } else {
          Alert.alert("", "刪除失敗，請再次嘗試。", [
            { text: "確定", type: "ok" },
          ]);
        }
      },
      onError(error) {
        Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
      },
    }
  );
  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }
  function getColor(date, state) {
    let deadline;
    if (!!date) {
      deadline = moment(date).diff(new Date(), "days");
    }

    if (
      state === "PENDING" ||
      state === "TO_BE_DECIDED" ||
      state === "FINISHED"
    ) {
      switch (state) {
        case "TO_BE_DECIDED":
          return "#ff9800";
        case "PENDING":
          return "#ffeb3b";
        case "FINISHED":
          return "#2196f3";
        default:
          break;
      }
    } else {
      if (deadline >= 7) {
        return "#2e7d32";
      } else if (deadline <= 6) {
        return "#d50000";
      }
    }
  }
  const useStyles = makeStyles({
    DocumentContainerEnd: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-end",
    },
  });
  const classes = useStyles();
  if (loading) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Card>
        <LoadingModal loading={deleteAssignmentLoading} />
        <CardContent>
          <Grid container spacing={1}>
            <Grid
              xs={6}
              sm={2}
              classes={{ root: classes.DocumentContainerEnd }}
            >
              <Box
                height="20px"
                width="20px"
                bgcolor="#ff9800"
                style={{ borderRadius: "50%" }}
              />
              <Typography>:待決策</Typography>
            </Grid>
            <Grid
              xs={6}
              sm={2}
              classes={{ root: classes.DocumentContainerEnd }}
            >
              <Box
                height="20px"
                width="20px"
                bgcolor="#ffeb3b"
                style={{ borderRadius: "50%" }}
              />
              <Typography>:還沒開始進行</Typography>
            </Grid>
            <Grid
              xs={6}
              sm={2}
              classes={{ root: classes.DocumentContainerEnd }}
            >
              <Box
                height="20px"
                width="20px"
                bgcolor="#2e7d32"
                style={{ borderRadius: "50%" }}
              />
              <Typography>:剩餘7天以上</Typography>
            </Grid>
            <Grid
              xs={6}
              sm={2}
              classes={{ root: classes.DocumentContainerEnd }}
            >
              <Box
                height="20px"
                width="20px"
                bgcolor="#d50000"
                style={{ borderRadius: "50%" }}
              />
              <Typography>:剩餘6天以下</Typography>
            </Grid>
            <Grid
              xs={6}
              sm={2}
              classes={{ root: classes.DocumentContainerEnd }}
            >
              <Box
                height="20px"
                width="20px"
                bgcolor="#2196f3"
                style={{ borderRadius: "50%" }}
              />
              <Typography>:已完成</Typography>
            </Grid>
          </Grid>
        </CardContent>
        <CardContent>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={2}>
              <TextInput
                value={newData.searchTerm}
                label={"關鍵字搜尋"}
                onChange={(v) => changeData("searchTerm", v, true)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <Select
                items={newData.statusArray}
                value={newData.statusObject}
                label={"狀態搜尋"}
                onChange={(e, v) => {
                  if (v) {
                    changeData("statusObject", v, true);
                  } else {
                    changeData("statusObject", {}, true);
                  }
                }}
                fullWidth
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardContent>
          <Grid container spacing={1} justify="flex-end">
            <Grid item>
              <Button
                color="primary"
                variant="contained"
                onPress={() => {
                  changeData("addOpen", true, true);
                }}
              >
                我要交辦
              </Button>
              <AssignmentsDialog
                open={newData.addOpen}
                onClose={(value) => {
                  changeData("addOpen", false, true);
                  if (value === "refetch") {
                    refetch();
                  }
                }}
              />
            </Grid>
            <Grid item>
              <Button
                color="primary"
                variant="contained"
                onPress={() => {
                  changeData("editCategoryOpen", true, true);
                }}
              >
                編輯交辦事項類別
              </Button>
              <EditAssignmentCategory
                open={newData.editCategoryOpen}
                onClose={() => {
                  changeData("editCategoryOpen", false, true);
                }}
              />
            </Grid>
          </Grid>
          <Table
            data={data ? data.personalMessages.contents : []}
            tableWidth={isPhone ? 3 : 2}
            header={[
              "屬性類別",
              "工作內容說明",
              "預計(需求)完成日期",
              "擔當者",
              "狀態燈號",
              "狀態更新時間",
              "預計完成日期",
              "最後更新者",
              "狀態說明",
              "操作",
              "刪除",
            ]}
            columns={[
              (item) => item.category.name,
              "task",
              (item) => moment(item.expectedFinishedAt).format("yyyy/MM/DD"),
              (item) => item.assignTo.fullName,
              (item) => (
                <>
                  <Grid container justifyContent="center">
                    <Box
                      height="20px"
                      width="20px"
                      style={{ borderRadius: "50%" }}
                      bgcolor={getColor(item.shouldFinishAt, item.status)}
                    />
                  </Grid>
                </>
              ),
              (item) => moment(item.updatedAt).format("yyyy/MM/DD"),
              (item) =>
                item.shouldFinishAt
                  ? moment(item.shouldFinishAt).format("yyyy/MM/DD")
                  : null,
              (item) => item.updatedBy.fullName,
              (item) => item.response,
              (item) => (
                <Button
                  color="primary"
                  variant="contained"
                  style={{ minWidth: "88px" }}
                  onPress={(e) => {
                    e.stopPropagation();
                    changeData("data", item);
                    changeData("editOpen", true, true);
                  }}
                  fullWidth
                >
                  編輯狀態
                </Button>
              ),
              (item) => (
                <Button
                  color="primary"
                  variant="contained"
                  onPress={(e) => {
                    e.stopPropagation();
                    Alert.alert("通知", "確定要刪除？", [
                      {
                        text: "確定",
                        onPress: () => {
                          deleteAssignment({ variables: { id: item.id } });
                        },
                        type: "ok",
                      },
                      {
                        text: "取消",
                        type: "cancel",
                      },
                    ]);
                  }}
                >
                  刪除
                </Button>
              ),
            ]}
            onPress={(item) => {
              changeData("data", item);
              changeData("replyOpen", true, true);
            }}
          />
          <ReplyDialog
            open={newData.replyOpen}
            onClose={(value) => {
              changeData("replyOpen", false, true);
              if (value === "refeth") {
                refetch();
              }
            }}
            data={newData.data}
          />
          <EditStatusDialog
            open={newData.editOpen}
            onClose={(value) => {
              changeData("editOpen", false, true);
              if (value === "refeth") {
                refetch();
              }
            }}
            data={newData.data}
          />
        </CardContent>
        <CardActions>
          <Grid container justifyContent="center">
            <Pagination
              count={
                Boolean(data) && data.personalMessages.pageCount
                  ? data.personalMessages.pageCount
                  : 1
              }
              size="large"
              color="primary"
              page={newData.page}
              onChange={(e, n) => {
                changeData("page", n, true);
              }}
            />
          </Grid>
        </CardActions>
      </Card>
    );
  }
}
function AssignmentsDialog({ open, onClose = () => {} }) {
  const Alert = useAlert();
  const [newData, setNewData] = useState({
    expectedFinishedAt: null,
    personArray: [],
    personObject: {},
    task: "",
    data: [],
    assignmentCategory: [],
    assignmentCategoryObject: {},
  });
  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }
  const { loading: usersLoading } = useQuery(GET_USERS, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onCompleted({ users }) {
      if (users) {
        let newUsers = [];
        users.contents.map((item) =>
          newUsers.push({
            label: item.fullName,
            value: item.id,
          })
        );
        changeData("personArray", newUsers, true);
      }
    },
    onError(error) {
      return Alert.notice(error.message.replace("GraphQL error: ", ""));
    },
  });
  const { refetch, loading: assignmentCategoriesLoading } = useQuery(
    GET_ASSIGNMENTCATEGORIES,
    {
      fetchPolicy: "network-only",
      notifyOnNetworkStatusChange: true,
      onCompleted({ assignmentCategories }) {
        if (assignmentCategories) {
          let newAssignmentCategory = [];
          assignmentCategories.map((item) =>
            newAssignmentCategory.push({
              label: item.name,
              value: item.name,
              categoryId: item.id,
            })
          );
          changeData("assignmentCategory", newAssignmentCategory, true);
        }
      },
      onError(error) {
        return Alert.notice(error.message.replace("GraphQL error: ", ""));
      },
    }
  );
  useEffect(() => {
    refetch();
  }, [open]);
  const [saveAssignment, { loading: saveAssignmentLoading }] = useMutation(
    SAVE_ASSIGNMENT,
    {
      onCompleted({ saveAssignment }) {
        if (saveAssignment) {
          Alert.alert("", "儲存成功", [
            {
              text: "確定",
              onPress: () => {
                onClose("refetch");
              },
              type: "ok",
            },
          ]);
        } else {
          Alert.alert("", "儲存失敗，請再次嘗試。", [
            { text: "確定", type: "ok" },
          ]);
        }
      },
      onError(error) {
        Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
      },
    }
  );
  function save() {
    const assignmentInput = {
      categoryId: newData.assignmentCategoryObject.categoryId,
      status: "TO_BE_DECIDED",
      task: newData.task,
      assignToUserId: newData.personObject.value,
      assignedByUserId: Number(localStorage.getItem("@fullhouseUserId")),
      expectedFinishedAt: newData.expectedFinishedAt,
    };
    saveAssignment({ variables: { assignmentInput } });
  }
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={"sm"}>
      <LoadingModal
        loading={
          saveAssignmentLoading || assignmentCategoriesLoading || usersLoading
        }
      />
      <DialogTitle align="center">新增交辦</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={1}>
          <Grid item sm={4} xs={12}>
            <Typography color="primary">分類</Typography>
            <Select
              items={newData.assignmentCategory}
              value={newData.assignmentCategoryObject}
              onChange={(e, v) => {
                changeData("assignmentCategoryObject", v, true);
              }}
              fullWidth
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <Typography color="primary">交辦人員</Typography>
            <Typography>
              {localStorage.getItem("@fullhouseUserFullName")}
            </Typography>
          </Grid>
          <Grid item sm={4} xs={12}>
            <Typography color="primary">預計(需求)完成日期</Typography>
            <DateInput
              value={newData.expectedFinishedAt}
              format="yyyy年MM月dd日"
              onChange={(v) => {
                changeData("expectedFinishedAt", v, true);
              }}
              fullWidth
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <Typography color="primary">擔當者</Typography>
            <Select
              items={newData.personArray}
              value={newData.personObject}
              onChange={(e, v) => {
                changeData("personObject", v, true);
              }}
              fullWidth
            />
          </Grid>
          <Grid item sm={12} xs={12}>
            <Typography color="primary">工作內容說明</Typography>
            <TextInput
              multiline
              rows={5}
              value={newData.task}
              onChange={(v) => {
                changeData("task", v, true);
              }}
              fullWidth
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container spacing={1} justify="center">
          <Grid item>
            <Button
              color="primary"
              variant="contained"
              onPress={() => {
                save();
              }}
            >
              儲存
            </Button>
          </Grid>
          <Grid item>
            <Button
              color="primary"
              variant="outlined"
              onPress={() => {
                onClose();
              }}
            >
              返回
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
function ReplyDialog({ open, onClose = () => {}, data }) {
  const [reply, setReply] = useState("");
  const [task, setTask] = useState("");
  const [shouldFinishAt, setShouldFinishAt] = useState(null);
  const Alert = useAlert();
  const [saveAssignment, { loading: saveAssignmentLoading }] = useMutation(
    SAVE_ASSIGNMENT,
    {
      onCompleted({ saveAssignment }) {
        if (saveAssignment) {
          Alert.alert("", "儲存成功", [
            {
              text: "確定",
              onPress: () => {
                onClose("refeth");
              },
              type: "ok",
            },
          ]);
        } else {
          Alert.alert("", "儲存失敗，請再次嘗試。", [
            { text: "確定", type: "ok" },
          ]);
        }
      },
      onError(error) {
        Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
      },
    }
  );
  function save() {
    const assignmentInput = {
      id: data.id,
      categoryId: data.category.id,
      task,
      status: data.status,
      response: reply,
      shouldFinishAt,
      assignToUserId: data.assignTo.id,
      assignedByUserId: data.assignedBy.id,
    };
    saveAssignment({ variables: { assignmentInput } });
  }
  useEffect(() => {
    if (!!data) {
      setTask(data.task);
      setShouldFinishAt(data.shouldFinishAt);
    }
  }, [data]);
  return (
    <Dialog
      open={open}
      onClose={() => {
        onClose();
      }}
      fullWidth
      maxWidth={"sm"}
    >
      <LoadingModal loading={saveAssignmentLoading} />
      <DialogTitle align="center">交辦回覆</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={1}>
          <Grid item sm={4} xs={6}>
            <Typography color="primary">交辦時間</Typography>
            <Typography>
              {moment(data.createdAt).format("yyyy/MM/DD")}
            </Typography>
          </Grid>
          <Grid item sm={4} xs={6}>
            <Typography color="primary">交辦人員</Typography>
            <Typography>{data.assignedBy?.fullName}</Typography>
          </Grid>
          <Grid item sm={4} xs={12}>
            <Typography color="primary">預計(需求)完成日期</Typography>
            <Typography>
              {moment(data.expectedFinishedAt).format("yyyy/MM/DD")}
            </Typography>
          </Grid>
          <Grid item sm={4} xs={6}>
            <Typography color="primary">擔當者</Typography>
            <Typography>{data.assignTo?.fullName}</Typography>
          </Grid>
          <Grid item sm={4} xs={6}>
            <Typography color="primary">預計完成日期</Typography>
            <DateInput
              value={shouldFinishAt}
              inputVariant="outlined"
              minDate={data.expectedFinishedAt}
              format="yyyy/MM/dd"
              onChange={(v) => setShouldFinishAt(v)}
            />
          </Grid>
          <Grid item sm={12} xs={12}>
            <Typography color="primary">工作內容說明</Typography>
            <TextInput
              value={task}
              multiline
              rows={5}
              onChange={(v) => {
                setTask(v);
              }}
              fullWidth
            />
          </Grid>
          <Grid item sm={12} xs={12}>
            <Typography color="primary">回覆過的內容</Typography>
            <div
              style={{ height: 80, border: "1px solid", borderRadius: "5px" }}
            >
              <Typography>{data.response}</Typography>
            </div>
          </Grid>
          <Grid item sm={12} xs={12}>
            <Typography color="primary">回覆</Typography>
            <TextInput
              value={reply}
              multiline
              rows={5}
              onChange={(v) => setReply(v)}
              fullWidth
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container spacing={1} justify="center">
          <Grid item>
            <Button color="primary" variant="contained" onPress={save}>
              儲存
            </Button>
          </Grid>
          <Grid item>
            <Button
              color="primary"
              variant="outlined"
              onPress={() => {
                onClose();
              }}
            >
              返回
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
function EditStatusDialog({ open, onClose = () => {}, data }) {
  const Alert = useAlert();
  const [updateAssignmentStatus, { loading: updateAssignmentStatusLoading }] =
    useMutation(UPDATE_ASSIGNMENTSTATUS, {
      onCompleted({ updateAssignmentStatus }) {
        if (updateAssignmentStatus) {
          Alert.alert("", "編輯成功", [
            {
              text: "確定",
              onPress: () => {
                onClose("refeth");
              },
              type: "ok",
            },
          ]);
        } else {
          Alert.alert("", "編輯失敗，請再次嘗試。", [
            { text: "確定", type: "ok" },
          ]);
        }
      },
      onError(error) {
        Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
      },
    });
  let statusArray = [
    {
      label: "待決策",
      value: "TO_BE_DECIDED",
    },
    {
      label: "未進行",
      value: "PENDING",
    },
    {
      label: "開始進行",
      value: "IN_PROGRESS",
    },
  ];
  const [statusObject, setStatusObject] = useState({
    label: "待決策",
    value: "TO_BE_DECIDED",
  });

  function save() {
    if (!data.shouldFinishAt && statusObject.value === "IN_PROGRESS") {
      return Alert.notice("未指定預計完成日期，無法開始進行！");
    }
    updateAssignmentStatus({
      variables: { id: data.id, assignmentStatus: statusObject.value },
    });
  }
  function getStatus(value) {
    switch (value) {
      case "TO_BE_DECIDED":
        return "待決策";
      case "PENDING":
        return "未進行";
      case "IN_PROGRESS":
        return "進行中";
      case "FINISHED":
        return "已完成";
      default:
        break;
    }
  }
  useEffect(() => {
    if (data.status === "IN_PROGRESS") {
      statusArray.push({
        label: "已完成",
        value: "FINISHED",
      });
    }
  }, [data]);
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={"xs"}>
      <DialogTitle align="center">編輯狀態</DialogTitle>
      <LoadingModal loading={updateAssignmentStatusLoading} />
      <DialogContent dividers>
        <Grid container spacing={1}>
          <Grid item sm={12} xs={12}>
            <Typography color="primary">當前狀態</Typography>
            <Typography>{getStatus(data.status)}</Typography>
          </Grid>
          <Grid item sm={12} xs={12}>
            <Typography color="primary">選擇狀態</Typography>
            <Select
              items={statusArray}
              value={statusObject}
              onChange={(e, v) => {
                if (v) {
                  setStatusObject(v);
                } else {
                  setStatusObject({});
                }
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container spacing={1} justify="center">
          <Grid item>
            <Button color="primary" variant="contained" onPress={save}>
              儲存
            </Button>
          </Grid>
          <Grid item>
            <Button
              color="primary"
              variant="outlined"
              onPress={() => {
                onClose();
              }}
            >
              返回
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}

function EditAssignmentCategory({ open, onClose = () => {} }) {
  const Alert = useAlert();
  const [assignmentCategory, setAssignmentCategory] = useState("");
  function initialization() {
    setAssignmentCategory("");
  }
  const { data, refetch, loading } = useQuery(GET_ASSIGNMENTCATEGORIES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onError(error) {
      return Alert.notice(error.message.replace("GraphQL error: ", ""));
    },
  });

  const [saveAssignmentCategory, { loading: saveAssignmentCategoryLoading }] =
    useMutation(SAVE_ASSIGNMENTCATEGORY, {
      onCompleted({ saveAssignmentCategory }) {
        if (saveAssignmentCategory) {
          return refetch();
        } else {
          return Alert.notice("新增失敗！");
        }
      },
      onError(error) {
        return Alert.notice(`${error}`);
      },
    });
  const [
    deleteAssignmentCategory,
    { loading: deleteAssignmentCategoryLoading },
  ] = useMutation(DELETE_ASSIGNMENTCATEGORY, {
    onCompleted({ deleteAssignmentCategory }) {
      if (deleteAssignmentCategory) {
        return refetch();
      } else {
        return Alert.notice("刪除失敗！");
      }
    },
    onError(error) {
      return Alert.notice(`${error}`);
    },
  });
  if (loading) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Dialog
        open={open}
        onClose={() => {
          onClose();
          initialization();
        }}
        fullWidth
        maxWidth="sm"
      >
        <LoadingModal
          loading={
            deleteAssignmentCategoryLoading || saveAssignmentCategoryLoading
          }
        />
        <DialogTitle align="center">編輯交辦事項類別</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item sm={10} xs={8}>
              <TextInput
                value={assignmentCategory}
                onChange={(v) => setAssignmentCategory(v)}
                fullWidth
              />
            </Grid>
            <Grid item sm={2} xs={4}>
              <Button
                color="primary"
                variant="outlined"
                size="small"
                onPress={() => {
                  saveAssignmentCategory({
                    variables: { name: assignmentCategory },
                  });
                  setAssignmentCategory("");
                }}
              >
                新增
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogContent>
          {data?.assignmentCategories.map((item) => (
            <Grid container spacing={1}>
              <Grid item sm={10} xs={8}>
                <Typography>{item.name}</Typography>
              </Grid>
              <Grid item sm={2} xs={4}>
                <Button
                  color="primary"
                  variant="outlined"
                  size="small"
                  onPress={() => {
                    deleteAssignmentCategory({ variables: { id: item.id } });
                  }}
                >
                  刪除
                </Button>
              </Grid>
            </Grid>
          ))}
        </DialogContent>
      </Dialog>
    );
  }
}
